export default __webpack_public_path__ + "static/飞书20210924-194535-271ead6177b0bea87105ef3526da0a6c.png";